const cards = [
  {
    title: '91视频 · 热门精选',
    desc: '汇聚91视频平台本周最受欢迎的高清资源，涵盖多元题材，每日更新推荐榜单，让您不错过任何热门内容。',
    tag: '热门',
    tagColor: 'bg-accent-100 text-accent-800',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20film%20reel%20with%20golden%20spotlight%20effect%2C%20abstract%20entertainment%20concept%2C%20soft%20coral%20and%20amber%20gradient%20background%2C%20minimal%20composition%2C%20professional%20movie%20poster%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '97视频 · 最新上线',
    desc: '97视频平台最新收录的精品内容合集，第一时间同步更新，高清画质流畅播放，满足您对新内容的探索欲。',
    tag: '新番',
    tagColor: 'bg-primary-100 text-primary-700',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20streaming%20interface%20with%20play%20button%20highlight%2C%20sleek%20dark%20UI%20elements%2C%20coral%20accent%20glow%2C%20clean%20minimal%20design%2C%20cinematic%20atmosphere&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '51视频网站 · 经典回顾',
    desc: '来自51视频网站的经典内容专区，收录历年高分佳作与观众票选Top作品，随时重温那些令人难忘的精彩瞬间。',
    tag: '经典',
    tagColor: 'bg-secondary-200 text-secondary-800',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20camera%20with%20warm%20nostalgic%20lighting%2C%20soft%20golden%20hour%20glow%2C%20retro%20aesthetic%20with%20modern%20twist%2C%20elegant%20minimal%20composition%2C%20professional%20product%20photography&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '数字视频平台 · 独家频道',
    desc: '数字视频平台独家合作频道，提供专属内容和幕后花絮，为您呈现普通渠道无法获取的独特视听体验。',
    tag: '独家',
    tagColor: 'bg-accent-100 text-accent-800',
    image: 'https://readdy.ai/api/search-image?query=Exclusive%20VIP%20content%20concept%20with%20warm%20golden%20spotlight%2C%20elegant%20dark%20background%20with%20coral%20highlights%2C%20premium%20cinematic%20feel%2C%20clean%20luxury%20aesthetic&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '高清专区 · 4K体验',
    desc: '精选超高清画质内容，支持多档清晰度自由切换。无论是大屏投屏还是移动观看，都能享受极致的视觉盛宴。',
    tag: '4K',
    tagColor: 'bg-primary-100 text-primary-700',
    image: 'https://readdy.ai/api/search-image?query=Ultra%20HD%20resolution%20display%20concept%20with%20vibrant%20coral%20and%20gold%20color%20spectrum%2C%20abstract%20digital%20art%2C%20clean%20geometric%20patterns%2C%20modern%20tech%20aesthetic%2C%20professional%20quality&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '免费专区 · 0门槛畅享',
    desc: '完全免费的高清视频专区，无需注册即可观看。覆盖91视频、97视频等全平台免费资源，真正做到零门槛畅享。',
    tag: '免费',
    tagColor: 'bg-secondary-200 text-secondary-800',
    image: 'https://readdy.ai/api/search-image?query=Open%20door%20concept%20with%20warm%20inviting%20light%2C%20soft%20golden%20and%20coral%20gradient%2C%20minimal%20architectural%20style%2C%20clean%20welcoming%20atmosphere%2C%20professional%20commercial%20photography&width=600&height=400&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            精选91视频、97视频、51视频网站及数字视频平台热门内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium ${card.tagColor}`}>
                    {card.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-play-fill text-background-50 text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const mediaItems = [
  {
    title: '91视频精选合集',
    desc: '91视频平台热门内容一周精选',
    duration: '2:15:30',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20strip%20with%20warm%20coral%20and%20golden%20highlights%2C%20abstract%20movie%20poster%20style%2C%20soft%20gradient%20background%2C%20elegant%20composition%2C%20professional%20entertainment%20visual&width=600&height=400&seq=media-01&orientation=landscape',
  },
  {
    title: '97视频最新更新',
    desc: '97视频本周上新内容速览',
    duration: '1:48:22',
    image: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20service%20visual%20with%20play%20icon%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20sleek%20minimal%20design%2C%20digital%20entertainment%20concept%2C%20clean%20professional%20aesthetic&width=600&height=400&seq=media-02&orientation=landscape',
  },
  {
    title: '51视频网站经典回顾',
    desc: '51视频网站历年人气最高内容盘点',
    duration: '3:02:15',
    image: 'https://readdy.ai/api/search-image?query=Retro%20film%20projector%20with%20warm%20nostalgic%20glow%2C%20soft%20golden%20light%20rays%2C%20vintage%20cinema%20aesthetic%20with%20modern%20touch%2C%20elegant%20minimal%20composition&width=600&height=400&seq=media-03&orientation=landscape',
  },
  {
    title: '数字视频平台独家放送',
    desc: '数字视频平台合作频道专属内容',
    duration: '0:56:48',
    image: 'https://readdy.ai/api/search-image?query=Exclusive%20digital%20content%20visual%20with%20warm%20spotlight%20effect%2C%20elegant%20dark%20background%20with%20coral%20accents%2C%20premium%20cinematic%20style%2C%20professional%20entertainment%20photography&width=600&height=400&seq=media-04&orientation=landscape',
  },
];

export function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            宅男视频各平台热门内容一览，点击即可跳转观看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-2xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const carouselItems = [
  {
    title: '91视频 · 年度精选大赏',
    desc: '回顾91视频平台过去一年最受好评的精彩内容，覆盖多元题材，高清画质带来沉浸式观影体验。',
    tag: '年度精选',
    image: 'https://readdy.ai/api/search-image?query=Grand%20award%20stage%20with%20warm%20golden%20spotlights%20and%20coral%20curtains%2C%20elegant%20cinema%20theater%20atmosphere%2C%20premium%20entertainment%20award%20visual%2C%20professional%20photography&width=600&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    title: '97视频 · 新锐创作者计划',
    desc: '97视频平台扶持的新锐内容创作者专题，发现最具潜力的原创力量，独家内容尽在宅男视频。',
    tag: '原创扶持',
    image: 'https://readdy.ai/api/search-image?query=Creative%20studio%20with%20warm%20ambient%20lighting%2C%20modern%20content%20creation%20setup%2C%20coral%20and%20golden%20accent%20decor%2C%20inspirational%20workspace%2C%20professional%20interior%20photography&width=600&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    title: '51视频 · 经典影库重映',
    desc: '51视频网站经典影库特别策划，精选历年来观众评分最高的作品进行高清重制，重温那些银幕经典。',
    tag: '经典重映',
    image: 'https://readdy.ai/api/search-image?query=Classic%20film%20archive%20with%20warm%20vintage%20lighting%2C%20old%20film%20reels%20on%20wooden%20shelves%2C%20golden%20nostalgic%20atmosphere%2C%20elegant%20library%20style%2C%20professional%20photography&width=600&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    title: '数字视频平台 · 技术前沿',
    desc: '数字视频平台最新技术应用专题，展示AI推荐、4K超清、HDR等前沿播放技术如何提升您的观看体验。',
    tag: '技术前沿',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20technology%20visual%20with%20warm%20coral%20and%20golden%20light%20streaks%2C%20abstract%20data%20flow%2C%20modern%20tech%20aesthetic%2C%20clean%20sci-fi%20style%2C%20professional%20digital%20art&width=600&height=400&seq=carousel-04&orientation=landscape',
  },
  {
    title: '宅男视频 · 社区精选合集',
    desc: '由宅男视频社区用户票选的最受欢迎内容合集，你的观看选择就是榜单排名，参与社区共建精彩。',
    tag: '社区票选',
    image: 'https://readdy.ai/api/search-image?query=Community%20voting%20concept%20with%20warm%20interactive%20visuals%2C%20coral%20and%20golden%20gradient%20background%2C%20people%20silhouettes%20with%20glowing%20highlights%2C%20modern%20social%20aesthetic&width=600&height=400&seq=carousel-05&orientation=landscape',
  },
  {
    title: '免费高清 · 周末影院',
    desc: '宅男视频周末特别策划，每周末更新一组精选免费高清内容，覆盖91视频、97视频等全平台资源。',
    tag: '周末特辑',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20warm%20ambient%20lighting%2C%20large%20screen%20with%20coral%20glow%2C%20comfortable%20atmosphere%2C%20weekend%20entertainment%20vibe%2C%20professional%20interior%20photography&width=600&height=400&seq=carousel-06&orientation=landscape',
  },
];

export function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            专题推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            宅男视频精心策划的专题内容，深度探索视频世界的无限精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row lg:flex-col"
            >
              <div className="relative sm:w-2/5 lg:w-full h-40 sm:h-auto lg:h-48 overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-800">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <div className="mt-3 flex items-center gap-1 text-primary-500 text-sm font-medium">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}